/* eslint-disable @typescript-eslint/no-explicit-any */
import type { UUID } from 'crypto';

import styled from 'styled-components';

import InlineLink from './InlineLink';
import ButtonOrLink from './ButtonOrLink';
import ClaimBlade from './ClaimBlade';

const LinkHeader = styled.div`
  color: ${({ theme }) => theme.colors.red};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: 200;
`;

const ProductLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  font-size: ${({ theme }) => theme.fontSizes[3]}px;
  margin: 12px 0px;

  span {
    text-decoration: none;
  }
`;

interface MainMenuProps {
  data: {
    bladeLinks: {
      id?: number | string | UUID;
      sectionHeading: string;
      links: {
        id: string;
        linkText: string;
        linkUrl: string;
        iconDamAsset: {
          asset: {
            localImage: {
              childImageSharp: {
                gatsbyImageData: any;
              };
            };
          };
        };
        internal: {
          type: string;
        };
        bladeType: string;
        title: string;
        closeLabel: string;
        button: {
          buttonLabel: string;
          buttonType: string;
          buttonUrl: string;
        };
        introParagraph: string;
        menu: {
          id: string;
          sectionHeading: string;
          links: {
            id: string;
            linkText: string;
            linkUrl: string;
            iconDamAsset: {
              asset: {
                localImage: {
                  childImageSharp: {
                    gatsbyImageData?: any;
                  };
                };
              };
            };
            internal: {
              type: string;
            };
          }[];
        }[];
      }[];
    }[];
    bladeCTAs: {
      id: string;
      buttonLabel: string;
      buttonType: string;
      buttonUrl: string;
    }[];
  };
}

const MainMenuV3 = ({ data }: MainMenuProps) => {
  const { bladeLinks } = data;

  return (
    <div>
      {bladeLinks?.map(({ id, sectionHeading, links }) => (
        <div
          key={id}
        >
          <div>
            <LinkHeader>{sectionHeading}</LinkHeader>
          </div>
          <ProductLinks>
            {links.map((link) => {
              if (
                link?.linkText
                      && link?.internal?.type === 'ContentfulLinkWrapper'
              ) {
                return link?.iconDamAsset ? (
                  <ButtonOrLink key={link.id} href={link.linkUrl}>
                    <div>
                      {link.linkText}
                    </div>
                  </ButtonOrLink>
                ) : (
                  <InlineLink key={link.id} href={link.linkUrl}>
                    {link.linkText}
                  </InlineLink>
                );
              }
              if (link?.internal.type === 'ContentfulBlade') {
                return link.bladeType === 'make-a-claim' ? (
                  <ClaimBlade
                    key={link.id}
                    title={link.title}
                    closeMsg={link.closeLabel}
                    cta={link.button}
                    intro={link.introParagraph}
                    menu={link.menu}
                  />
                ) : null;
              }
              return null;
            })}
          </ProductLinks>
        </div>
      ))}
    </div>
  );
};

export default MainMenuV3;
